"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.elementHelper = exports.hasPlaceholderFrame = exports.hasLayoutBox = exports.isQRCode = exports.isIcon = exports.isLogo = exports.isSticker = exports.isImage = exports.isVideo = exports.isOfType = exports.getElementType = exports.TYPE = void 0;
exports.TYPE = {
    Image: 'image',
    Sticker: 'sticker',
    Video: 'video',
    Logo: 'logo',
    Icon: 'icon',
    QRCode: 'qrcode',
};
function getElementType(element) {
    const elementType = Object.keys(exports.TYPE).find((type) => { var _a; return element && ((_a = element.classList) === null || _a === void 0 ? void 0 : _a.contains(exports.TYPE[type])); }) || '';
    return exports.TYPE[elementType] || null;
}
exports.getElementType = getElementType;
function isOfType(element) {
    return (type) => getElementType(element) === type;
}
exports.isOfType = isOfType;
const isVideo = (element) => isOfType(element)(exports.TYPE['Video']);
exports.isVideo = isVideo;
const isImage = (element) => isOfType(element)(exports.TYPE['Image']);
exports.isImage = isImage;
const isSticker = (element) => isOfType(element)(exports.TYPE['Sticker']);
exports.isSticker = isSticker;
const isLogo = (element) => isOfType(element)(exports.TYPE['Logo']);
exports.isLogo = isLogo;
const isIcon = (element) => isOfType(element)(exports.TYPE['Icon']);
exports.isIcon = isIcon;
const isQRCode = (element) => {
    var _a;
    return (((_a = element.classList) === null || _a === void 0 ? void 0 : _a.contains(exports.TYPE['QRCode'])) ||
        !!element.querySelector(exports.TYPE['QRCode']));
};
exports.isQRCode = isQRCode;
const hasLayoutBox = (element) => {
    var _a, _b;
    return (_b = (_a = element.classList) === null || _a === void 0 ? void 0 : _a.contains('layoutBox')) !== null && _b !== void 0 ? _b : false;
};
exports.hasLayoutBox = hasLayoutBox;
const hasPlaceholderFrame = (element) => {
    var _a, _b;
    return (_b = (_a = element.classList) === null || _a === void 0 ? void 0 : _a.contains('placeholder-frame')) !== null && _b !== void 0 ? _b : false;
};
exports.hasPlaceholderFrame = hasPlaceholderFrame;
function elementHelper(element) {
    return {
        getElementType: () => getElementType(element),
        hasLayoutBox: () => (0, exports.hasLayoutBox)(element),
        hasPlaceholderFrame: () => (0, exports.hasPlaceholderFrame)(element),
        isOfType: isOfType(element),
        isIcon: () => (0, exports.isIcon)(element),
        isImage: () => (0, exports.isImage)(element),
        isLogo: () => (0, exports.isLogo)(element),
        isSticker: () => (0, exports.isSticker)(element),
        isVideo: () => (0, exports.isVideo)(element),
        isQRCode: () => (0, exports.isQRCode)(element),
    };
}
exports.elementHelper = elementHelper;
//# sourceMappingURL=element-utils.js.map